export enum CardPaymentMethodStatus {
  NOT_DEFINED = 'NOT_DEFINED',
  READY = 'READY',
}
